import api from '@/utils/axios';

function assertSuccess(response, fallbackMessage) {
  if (!response.data?.success) {
    throw new Error(response.data?.error?.message || fallbackMessage);
  }
  return response.data;
}

export async function fetchFilterPresets(scope) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('presets/list', { token, scope });
  const data = assertSuccess(response, 'Failed to load filter presets');
  return data.data?.presets || [];
}

export async function saveFilterPreset({ scope, name, filters, presetId }) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('presets/save', { token, scope, name, filters, presetId });
  const data = assertSuccess(response, 'Failed to save filter preset');
  return data.data || {};
}

export async function deleteFilterPreset(presetId) {
  const token = localStorage.getItem('srToken');
  const response = await api.post('presets/delete', { token, presetId });
  const data = assertSuccess(response, 'Failed to delete filter preset');
  return data.data || {};
}
